import React, { Component } from 'react';

class Tooltip extends Component {
	render() {
		return (
			<>
				<div
					id="tooltip"
					style={{
						visibility: 'hidden',
						position: 'fixed',
						backgroundColor: '#FFF',
						padding: '16px',
						borderRadius: '5px',
						border: '2px solid #555',
						boxShadow:
							'rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px',
					}}
				>
					tooltip text
				</div>
				<div>
					
				</div>
			</>
		);
	}
}

export default Tooltip;
